import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LOCAL_STORAGE_JWT_TOKEN } from '../services/shared.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const isAuthenticated = !!localStorage.getItem(LOCAL_STORAGE_JWT_TOKEN);
  if (!isAuthenticated) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
